// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"cmp-Checkbox__checkbox__checkboxWrapper","checkboxSVG":"cmp-Checkbox__checkbox__checkboxSVG"};